/* eslint-disable */
import React, { useEffect, useContext, useMemo } from 'react';
import { flowRight, get, isArray, isEmpty } from 'lodash';
import { connect, useDispatch } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson, set } from 'session';
import { setList } from 'api/actions';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ModalContext } from 'App';
import moment from 'moment';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import CmsContext from 'context/CmsContext';
import TransactionInformation from '../components/TransactionInformation';
import TaxpayerInformation from '../components/TaxpayerInformation';
import BusinessInformation from '../components/BusinessInformation';
import BusinessAddress from '../components/BusinessAddress';
import BusinessActivities from '../components/BusinessActivities';
import FireSafetyInformation from '../components/FireSafetyInformation';
import FinalFeesInformation from '../components/FinalFeesInformation';
import Requirements from '../components/Requirements';
import UpdateModal from '../modals/UpdateModal';
// import Location from '../components/Location';
import AddRemarksModal from '../components/AddRemarksModal';
import * as actions from '../actions';
import * as cmsActions from 'modules/settings/cms/action';
import * as c from '../constant';
import * as cmsConstants from 'modules/settings/cms/constant';
import { getInitials } from '../helper';
import { convertToNumber } from 'utils/convertToNumber';
import useStartAssessment from '../hooks/useStartAssessment';
import useStartLicenseAssessment from '../hooks/useStartLicenseAssessment';
import useGenerateBIN from '../hooks/useGenerateBIN';
import useInitialComputation from '../hooks/useInitialComputation';
import InitialComputationModal from '../modals/InitialComputationModal';
import useApproveConfirmation from '../hooks/useApproveConfirmation';
import useRejectConfirmation from '../hooks/useRejectConfirmation';
import useReleaseConfirmation from '../hooks/useReleaseConfirmation';
import useGenerateSOAConfirmation from '../hooks/useGenerateSOAConfirmation';
import useApproveOwnershipConfirmation from '../hooks/useApproveOwnershipConfirmation';
import useForwardToLicense from '../hooks/useForwardToLicense';

import ViewSOA from '../components/ViewSOA';
import ViewOR from '../components/ViewOR';
import ViewPermit from '../components/ViewPermit';
import ViewGeneratedBin from '../components/ViewGeneratedBin';
import ViewLogs from '../components/ViewLogs';
import ChangeRequestModal from '../modals/ChangeRequest/ChangeRequestModal';
import RetirementModal from '../modals/Retirement/RetirementModal';
import ViewUpdateCalculation from '../components/ViewUpdateCalculation';
// import ViewUpdateCalculationRetirement from '../components/ViewUpdateCalculationRetirement';
import useCancelSoa from '../hooks/useCancelSoa';
import ViewApplication from '../components/ViewApplication';
import useCancelApplication from '../hooks/useCancelApplication';
import AssessRenewApplicationModal from '../modals/AssessRenewApplicationModal';
import useReturnToPermit from '../hooks/useReturnToPermit';
import RecalCalculateSOADate from '../modals/RecalCalculateSOADate';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import PreviousOR from '../components/PreviousOR';
// import UploadCTCModal from '../modals/UploadCTCModal';
// import useRenewalStartAssessment from '../hooks/useRenewalStartAssessment';
// import useRenewalApprove from '../hooks/useRenewalApprove';
// import useRenewalReturnToAssessment from '../hooks/useRenewalReturnToAssessment';
// import useRenewalStartLicenseAssessment from '../hooks/useRenewalStartLicenseAssessment';
import PaymentPostingModal from '../components/PaymentPostingModal';
import UpdateBilling from '../modals/UpdateBilling';
import UpdateBusinessState from '../modals/UpdateBusinessState';
import UpdateOrDate from '../modals/UpdateOrDate';
// import ManualPaymentPostingModal from '../modals/ManualPaymentPostingModal';
import useForwardToEndorsingOffice from '../hooks/useForwardToEndorsingOffice';
import EndorsingOffices from '../components/endorsingOffices/EndorsingOffices';
import RequirementsTabs from '../components/RequirementsTabs';
import EndorsingOfficeModal from '../modals/EndorsingOfficeModal';
import ApplyDiscountModal from '../components/ApplyDiscountModal';
import UpdateRegistry from '../components/UpdateRegistry';
import AssessApplication from '../modals/Retirement/AssessApplication';
import ViewAnnualSOA from '../components/ViewAnnualSOA';
import useValidateQuarterlyBusiness from '../hooks/useValidateQuarterlyBusiness';
import UpdateBarangayBusinessClearanceNumber from '../modals/UpdateBarangayBusinessClearanceNumber';
import { toWords } from 'number-to-words';
import { PAGE_DIMENSIONS } from 'lib/tiny-mce';
import { parseString } from 'utils/parseString';
import DOMPurify from 'dompurify';

function Content({
  getListCms,
  getPaperList,
  itemSettings,
  match,
  getItem,
  item,
  permitApplication,
  adminProfile,
  isLoading,
  toggleAssessment,
  toggleLicenseAssessment,
  assisting,
  generatingBIN,
  generateBIN,
  initialComputing,
  initialComputation,
  approving,
  approve,
  rejecting,
  // reject,
  releasing,
  release,
  ownershipApproving,
  approveOwnership,
  permissions,
  list,
  refreshList,
  generatingSOA,
  generateSOA,
  forwardingToLicense,
  forwardToLicense,
  cancellingSoa,
  cancelSoa,
  cancellingApplication,
  cancelApplication,
  returningToPermit,
  returnToPermit,
  recalculatingSOA,
  recalculateSOA,
  inquirePreviousOR,
  getPermitList,
  getList,
  param,
  forwardingToEndorsingOffice,
  forwardToEndorsingOffice,
  forPickUp,
  issued,
  getEndorsingOfficesList,
  endorsingOfficesList,
  revokeBarangayClearance,
  onRevoke,
  validateBusinessActivity,
  validateBusiness,
  validatingBusiness,
  getBarangayDetails,
  barangayDetails,
  id,
  getReportAccess,
}) {
  const dispatch = useDispatch();
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const permitApplicationIncluded = get(permitApplication, 'included', []);
  const transactionType = get(item, 'attributes.transaction_type', '');
  const permitType = get(item, 'included.bplsApplication.attributes.type');
  const itemAppStatus = get(item, 'included.bplsApplication.attributes.status');
  const permitApplicationBplsBusinesses = permitApplicationIncluded.find(
    (i) => i.type === 'bpls_businesses'
  );
  const barangayCode = get(
    permitApplicationBplsBusinesses,
    'attributes.main_office_barangay_code',
    ''
  );
  const showFsisIntegration = !!_.get(CMS_COMPONENTS, 'FSIS_INTEGRATION');
  const fsisApplication =
    get(item, 'included.bplsFsisApplication') ||
    (Array.isArray(get(item, 'included.bplsFsisApplications'))
      ? get(item, 'included.bplsFsisApplications[0]')
      : get(item, 'included.bplsFsisApplications')) ||
    {};

  useEffect(() => {
    getList({ type: 'BUSINESS_PERMITS' });
  }, []);

  useEffect(() => {
    if (!barangayCode) return;
    getBarangayDetails({ code: barangayCode });
  }, [barangayCode]);

  const paperSetup = useMemo(() => {
    if (!itemSettings) return {};
    const parsedItem = parseString(itemSettings);
    const attrib = _.get(parsedItem, 'attributes', {});
    const body = _.get(attrib, 'body', '[]');
    const parsedBody = parseString(body);
    if (!isArray(parsedBody)) return {};
    const selectedPermit = parsedBody.find((b) => b?.selected);
    return _.get(selectedPermit, 'paper_setup', {});
  }, [itemSettings]);

  set(
    'applicationStatusId',
    JSON.stringify(get(item, 'attributes.application_status_id') || 0)
  );

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    getItem(match.params.bpls_id);
  };

  const generatePrintStyles = () => {
    const {
      bottom = '0',
      left = '0',
      paper_margin = '0',
      paper_orientation = 'portrait',
      paper_size = 'letter',
      right = '0',
      top = '0',
    } = paperSetup || {};

    const pageDimensions = PAGE_DIMENSIONS[paper_orientation][paper_size];

    return `
      <style>
       @page { 
        size: ${pageDimensions}; 
        margin: ${top}${paper_margin} ${right}${paper_margin} ${bottom}${paper_margin} ${left}${paper_margin}; 
       }
      </style>
    `;
  };

  // const selectedTransaction = match.params.id;

  const isStartAssessment = get(item, 'attributes.is_start_assessment');
  const isValidated = get(
    item,
    'included.bplsApplication.attributes.is_validated'
  );
  const isDelinquent =
    get(item, 'attributes.transaction_type') === 'DELINQUENT';
  const isRetirement =
    get(item, 'attributes.transaction_type') === 'RETIREMENT';
  const isNew = get(item, 'attributes.transaction_type') === 'NEW';

  const startAssessment = useStartAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    () => {
      toggleAssessment(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  // const renewalStartAssessment = useRenewalStartAssessment(
  //   assisting,
  //   isStartAssessment,
  //   get(item, 'attributes.transaction_status'),
  //   itemAppStatus,
  //   () => {
  //     toggleAssessment(get(item, 'id'), {}, () => {
  //       getItem(get(item, 'id'));
  //     });
  //   }
  // );

  const startLicenseAssessment = useStartLicenseAssessment(
    assisting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    () => {
      toggleLicenseAssessment(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const forwardToEndorsingOfficeConfirmation = useForwardToEndorsingOffice(
    forwardingToEndorsingOffice,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    isNew,
    get(item, 'included.bplsBusiness.attributes.bin'),
    get(item, 'attributes.start_assess_by'),
    () => {
      forwardToEndorsingOffice(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  // const renewalStartLicenseAssessment = useRenewalStartLicenseAssessment(
  //   assisting,
  //   isStartAssessment,
  //   get(item, 'attributes.transaction_status'),
  //   itemAppStatus,
  //   () => {
  //     toggleLicenseAssessment(get(item, 'id'), {}, () => {
  //       getItem(get(item, 'id'));
  //     });
  //   }
  // );

  const initialComputationHooks = useInitialComputation(
    initialComputing,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    get(item, 'attributes.soa_generated_at'),
    () => {
      initialComputation(get(item, 'id'), {}, (res) => {
        getItem(get(item, 'id'));
        dispatch(setList(`${c.INITIAL_COMPUTATION}`, get(res, 'res.data')));
        setModal({
          isOpen: true,
          content: <InitialComputationModal permitId={+match.params.bpls_id} />,
          title: 'Initial Computation',
          modalSize: 'modal-lg',
        });
      });
    }
  );

  const generateBINHooks = useGenerateBIN(
    generatingBIN,
    get(item, 'included.bplsBusiness.attributes.bin'),
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    isValidated,
    () => {
      generateBIN(get(item, 'id'), {}, (response) => {
        setTimeout(() => {
          getPermitList(param);
          getItem(get(item, 'id'));
          setModal({
            isOpen: true,
            content: <ViewGeneratedBin data={response} />,
            title: 'Generated BIN',
            modalSize: 'modal-md',
          });
        }, 3000);
      });
    }
  );

  const approveOwnershipComputation = useApproveOwnershipConfirmation(
    ownershipApproving,
    get(item, 'included.bplsBusiness.attributes.bin'),
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    get(item, 'included.bplsBusiness.attributes.taxpayer_id'),
    () => {
      approveOwnership(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const approveConfirmation = useApproveConfirmation(
    approving,
    get(item, 'included.bplsBusiness.attributes.bin'),
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    () => {
      approve(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const rejectConfirmation = useRejectConfirmation(
    rejecting,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    isDelinquent,
    isRetirement,
    get(item, 'id')
  );

  const releaseConfirmation = useReleaseConfirmation(
    releasing,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    (remarks) => {
      release(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const handleGenerateSOA = () => {
    generateSOA(get(item, 'id'), {}, () => {
      getItem(get(item, 'id'));
      handleViewSOA();
    });
  };

  const generateSOAConfirmation = useGenerateSOAConfirmation(
    generatingSOA,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    get(item, 'attributes.soa_generated_at'),
    transactionType !== 'DELINQUENT' && transactionType !== 'RETIREMENT'
      ? () => handleGenerateSOA()
      : () => {
          transactionType === 'DELINQUENT'
            ? setModal({
                isOpen: true,
                content: (
                  <ViewUpdateCalculation
                    data={item}
                    handleGenerateSOA={handleGenerateSOA}
                  />
                ),
                title: 'Update Delinquent Calculation',
                modalSize: 'modal-xl',
              })
            : setModal({
                isOpen: true,
                content: (
                  <AssessApplication
                    data={item}
                    handleGenerateSOA={handleGenerateSOA}
                  />
                ),
                title: 'Update Retirement Calculation',
                modalSize: 'modal-xl',
              });
        }
  );

  const forwardToLicenseConfirmation = useForwardToLicense(
    forwardingToLicense,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    () => {
      forwardToLicense(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  // const renewalApproveConfirmation = useRenewalApprove(
  //   forwardingToLicense,
  //   isStartAssessment,
  //   get(item, 'attributes.transaction_status'),
  //   itemAppStatus,
  //   () => {
  //     forwardToLicense(get(item, 'id'), {}, () => {
  //       toggleLicenseAssessment(get(item, 'id'), {}, () => {
  //         getItem(get(item, 'id'));
  //       });
  //     });
  //   }
  // );

  const cancelSoaConfirmation = useCancelSoa(
    cancellingSoa,
    get(item, 'attributes.soa_generated_at'),
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    (remarks) => {
      cancelSoa(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const cancelApplicationConfirmation = useCancelApplication(
    cancellingApplication,
    itemAppStatus,
    (remarks) => {
      cancelApplication(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const returnToPermitConfirmation = useReturnToPermit(
    returningToPermit,
    isStartAssessment,
    itemAppStatus,
    (remarks) => {
      returnToPermit(get(item, 'id'), { remarks }, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  const handleUpdateRegistry = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateRegistry
          id={_.get(item, 'id')}
          updateList={get(item, 'included.bplsApplication.attributes')}
        />
      ),
      title: 'Update Business Plate Number ',
      modalSize: 'modal-md',
    });
  };

  // const renewalReturnToAssessmentConfirmation = useRenewalReturnToAssessment(
  //   returningToPermit,
  //   isStartAssessment,
  //   itemAppStatus,
  //   remarks => {
  //     returnToPermit(get(item, 'id'), { remarks }, () => {
  //       getItem(get(item, 'id'));
  //     });
  //   }
  // );

  // const handlePreviousOR = (e) => {
  //   e.preventDefault();

  //   inquirePreviousOR(get(item, 'id'), () => {
  //     setModal({
  //       isOpen: true,
  //       content: <PreviousOR data={item} />,
  //       title: `Previous OR`,
  //       modalSize: 'modal-xl',
  //     });
  //   });
  // };

  const handleApplyDiscount = () => {
    getItem(match.params.bpls_id, ({ data: permit }) => {
      const appliedDiscount = _.get(
        permit,
        'included.bplsAppliedDiscount.attributes',
        {}
      );
      const amount = _.get(appliedDiscount, 'total_amount', 0);
      const discount = _.get(appliedDiscount, 'discount', 0);
      const originalAmount = _.get(appliedDiscount, 'original_amount', 0);
      const code = _.get(appliedDiscount, 'code', '');
      const id = _.get(permit, 'id', '');
      const description = _.get(appliedDiscount, 'description', '');
      const title = Number(_.get(item, 'attributes.discount'))
        ? 'Update Discount'
        : 'Apply Discount';

      setModal({
        isOpen: true,
        title,
        modalSize: 'modal-md',
        content: (
          <ApplyDiscountModal
            // generateSOA={generateSOA}
            // item={item}
            amount={convertToNumber(amount)}
            discount={convertToNumber(discount)}
            originalAmount={convertToNumber(originalAmount)}
            id={id}
            code={code}
            handleGenerateSOA={handleGenerateSOA}
            description={description}
          />
        ),
      });
    });
  };

  const handleViewSOA = () => {
    setModal({
      isOpen: true,
      content: (
        <ViewSOA data={item} handleApplyDiscount={handleApplyDiscount} />
      ),
      title: `View e-SOA`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewAnnualSOA = () => {
    setModal({
      isOpen: true,
      content: <ViewAnnualSOA data={item} />,
      title: `View Annual e-SOA`,
      modalSize: 'modal-xl',
    });
  };

  // const handleViewOR = (e) => {
  //   e.preventDefault();

  //   setModal({
  //     isOpen: true,
  //     content: <ViewOR data={item} />,
  //     title: `View e-OR`,
  //     modalSize: 'modal-xl',
  //   });
  // };

  const generateTable = (fees) => {
    let tableHtml = `<table style="border-collapse: collapse; width: 100.337%; height: 102px; border-width: 1px; border-style: none;" border="1">
    <colgroup>
      <col style="width: 74.4042%;">
      <col style="width: 25.6093%;">
    </colgroup>
    <tbody>`;

    fees.forEach((item) => {
      if (_.get(item, 'attributes.total_human', '') !== '0.00') {
        tableHtml += `
        <tr style="height: 20.4px;">
          <td style="text-align: left; border-style: none;"><span style="font-size: 10pt;">${_.get(
            item,
            'attributes.description',
            ''
          )}</span></td>
          <td style="text-align: left; border-style: none;"><span style="font-size: 10pt;">${_.get(
            item,
            'attributes.total_human',
            ''
          )}</span></td>
        </tr>`;
      }
    });

    // Close table tags
    tableHtml += `
    </tbody>
  </table>`;

    return tableHtml;
  };

  const generateActivities = (activities) => {
    let tableHtml = `<table style="border-collapse: collapse; width: 100%; border-width: 1px; border-style: none;" border="1">
    <colgroup>
      <col style="width: 74.4042%;">
    </colgroup>
    <tbody>`;

    activities.forEach((item) => {
      const name = _.get(item, 'business_line_name');
      tableHtml += `
       <tr style="height: 20.4px;">
        <td style="text-align: center; border-style: none;">
          <span style="font-size: 10pt;">
            ${name}
          </span>
        </td>
      </tr>`;
    });

    // Close table tags
    tableHtml += `
    </tbody>
  </table>`;

    return tableHtml;
  };

  const generateRetirementsActivities = (activities) => {
    let tableHtml = `<table style="border-collapse: collapse; width: 100%; border-width: 1px; border-style: none;" border="1">
    <colgroup>
      <col style="width: 74.4042%;">
    </colgroup>
    <tbody>`;

    activities.forEach((item) => {
      const name = _.get(item, 'business_line_name');
      tableHtml += `
       <tr style="height: 20.4px;">
        <td style="text-align: center; border-style: none;">
          <span style="font-size: 10pt;">
            ${name}
          </span>
        </td>
      </tr>`;
    });

    // Close table tags
    tableHtml += `
      </tbody>
    </table>`;

    return tableHtml;
  };

  const generateActivitiesPSIC = (activities) => {
    let tableHtml = `<table style="border-collapse: collapse; width: 100%; border-width: 1px; border-style: none;" border="1">
    <colgroup>
      <col style="width: 74.4042%;">
    </colgroup>
    <tbody>`;

    activities.forEach((item) => {
      const name = _.get(item, 'business_line_name');
      const code = _.get(item, 'business_line_code');
      tableHtml += `
       <tr style="height: 20.4px;">
        <td style="text-align: center; border-style: none;">
          <span style="font-size: 10pt;">
            ${code} - ${name}
          </span>
        </td>
      </tr>`;
    });

    // Close table tags
    tableHtml += `
    </tbody>
  </table>`;

    return tableHtml;
  };

  const generateBarangayFees = (list) => {
    if (isEmpty(list) || !Array.isArray(list)) return 'N/A';

    let tableHtml = `<table style="width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; font-size: 12px;">
      <thead>
        <tr style="background-color: #f8f9fa;">
          <th style="padding: 8px 12px; text-align: left; border-bottom: 1px solid #dee2e6; font-weight: 600;">Code</th>
          <th style="padding: 8px 12px; text-align: left; border-bottom: 1px solid #dee2e6; font-weight: 600;">Description</th>
          <th style="padding: 8px 12px; text-align: right; border-bottom: 1px solid #dee2e6; font-weight: 600;">Total</th>
        </tr>
      </thead>
      <tbody>`;

    list.forEach((item, index) => {
      tableHtml += `
        <tr style="${
          index % 2 === 0
            ? 'background-color: #ffffff;'
            : 'background-color: #f8f9fa;'
        }">
          <td style="padding: 6px 12px; border-bottom: 1px solid #e9ecef;">${
            item.code
          }</td>
          <td style="padding: 6px 12px; border-bottom: 1px solid #e9ecef;">${
            item.description
          }</td>
          <td style="padding: 6px 12px; border-bottom: 1px solid #e9ecef; text-align: right;">${
            item.total_human
          }</td>
        </tr>`;
    });

    tableHtml += `
      </tbody>
    </table>`;

    return tableHtml;
  };

  const replacePlaceholders = (html, values, combinedData) => {
    const fees = get(item, 'included.bplsPermitFees', []);
    let updatedHtml = html;
    const bplsActivitiesArray = permitApplicationIncluded
      .filter((item) => item.type === 'bpls_business_activities')
      .map((item) => item.attributes);
    const bplsRetirementsActivitiesArray = permitApplicationIncluded
      .filter((item) => item.type === 'bpls_business_retirements_activities')
      .map((item) => item.attributes);

    for (const key in values) {
      if (Object.hasOwnProperty.call(values, key)) {
        const tag = `[${key}]`;
        let replacementValue = values[key];

        if (key === 'or_no') {
          if (_.get(item, 'included.bplsApplication.attributes.or_no')) {
            replacementValue = _.get(
              item,
              'included.bplsApplication.attributes.or_no'
            ).replace(/, /g, '<br>');
          } else {
            replacementValue = _.get(
              item,
              'included.bplsApplication.attributes.e_or_no'
            );
          }
        }

        if (key === 'address') {
          replacementValue = _.get(
            item,
            'included.taxPayer.attributes.address'
          );
        }

        if (key === 'printed_date') {
          replacementValue = moment(combinedData.printed_date).format('L');
        }

        if (key === 'printed_date_day') {
          replacementValue = moment(combinedData.printed_date).format('DD');
        }

        if (key === 'printed_date_day_ordinal') {
          replacementValue = moment(combinedData.printed_date).format('Do');
        }

        if (key === 'printed_date_month') {
          replacementValue = moment(combinedData.printed_date).format('MMMM');
        }

        if (key === 'printed_date_year') {
          replacementValue = moment(combinedData.printed_date).format('YYYY');
        }

        if (key === 'printed_days_of_week') {
          replacementValue = moment(combinedData.printed_date).format('dddd');
        }

        if (key === 'validity_date') {
          replacementValue = moment().endOf('year').format('DD MMM YYYY');
        }

        if (key === 'qr_url') {
          replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${values[key]}" alt="" width="111" height="111"></span></strong></p>`;
        }

        if (key === 'fees') {
          replacementValue = generateTable(fees);
        }

        if (key === 'business_line_with_code') {
          const businessLineCode = _.get(
            combinedData,
            'business_line_code',
            'N/A'
          );
          const businessLineName = _.get(
            combinedData,
            'business_line_name',
            'N/A'
          );
          replacementValue = `
            <p style="font-size: 10pt;">
              ${businessLineCode} - ${businessLineName}
            </p>
          `;
        }

        if (key === 'business_lines') {
          replacementValue = generateActivities(bplsActivitiesArray);
        }

        if (key === 'business_lines_with_code') {
          replacementValue = generateActivitiesPSIC(bplsActivitiesArray);
        }

        if (key === 'retired_business_lines') {
          replacementValue = generateRetirementsActivities(
            bplsRetirementsActivitiesArray
          );
        }

        if (key === 'signatory_1_name') {
          replacementValue = _.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_ONE_NAME',
            ''
          );
        }

        if (key === 'signatory_1_designation') {
          replacementValue = _.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_ONE_DESIGNATION',
            ''
          );
        }

        if (key === 'signatory_1_signature') {
          replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_ONE_SIGNATURE',
            ''
          )}" alt="" width="111" height="111"></span></strong></p>`;
        }

        if (key === 'signatory_2_name') {
          replacementValue = _.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_TWO_NAME',
            ''
          );
        }

        if (key === 'signatory_2_designation') {
          replacementValue = _.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_TWO_DESIGNATION',
            ''
          );
        }

        if (key === 'signatory_2_signature') {
          replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_TWO_SIGNATURE',
            ''
          )}" alt="" width="111" height="111"></span></strong></p>`;
        }

        if (key === 'signatory_3_name') {
          replacementValue = _.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_THREE_NAME',
            ''
          );
        }

        if (key === 'signatory_3_designation') {
          replacementValue = _.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_THREE_DESIGNATION',
            ''
          );
        }

        if (key === 'signatory_3_signature') {
          replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
            CMS_COMPONENTS,
            'BPLS_SIGNATORY_THREE_SIGNATURE',
            ''
          )}" alt="" width="111" height="111"></span></strong></p>`;
        }

        if (
          key === 'barangay_clearance_signatory_signature' ||
          key === 'barangay_logo'
        ) {
          replacementValue = `
            <p>
              <strong>
                <span style="font-size: 10pt;">
                  <img style="display: block; margin-left: auto; margin-right: auto;" 
                    src="${_.get(
                      combinedData,
                      key
                    )}" alt="" width="111" height="111" />
                </span>
              </strong>
            </p>
          `;
        }

        if (key === 'brgy_fees') {
          const list = _.get(combinedData, key, []);
          replacementValue = generateBarangayFees(list);
        }

        if (key === 'amount_in_words') {
          const amount = parseFloat(
            values.total_human?.replace(/[^\d.]/g, '') || 0
          );
          const pesos = Math.floor(amount);
          const centavos = Math.round((amount - pesos) * 100);
          const wordsResult = `${toWords(pesos)} pesos${
            centavos > 0 ? ` and ${toWords(centavos)} centavos` : ''
          }`;
          replacementValue = wordsResult.replace(/\b\w/g, (l) =>
            l.toUpperCase()
          );
        }

        if (key === 'or_date_day') {
          replacementValue = moment(combinedData.or_date).format('DD');
        }

        if (key === 'or_date_month') {
          replacementValue = moment(combinedData.or_date).format('MMMM');
        }

        if (key === 'or_date_year') {
          replacementValue = moment(combinedData.or_date).format('YYYY');
        }

        if (key === 'or_days_of_week') {
          replacementValue = moment(combinedData.or_date).format('dddd');
        }

        if (key === 'or_date_latest_day') {
          replacementValue = moment(combinedData.latest_or_date).format('DD');
        }

        if (key === 'or_date_latest_month') {
          replacementValue = moment(combinedData.latest_or_date).format('MMMM');
        }

        if (key === 'or_date_latest_year') {
          replacementValue = moment(combinedData.latest_or_date).format('YYYY');
        }

        if (key === 'or_days_latest_of_week') {
          replacementValue = moment(combinedData.latest_or_date).format('dddd');
        }

        if (key === 'or_date_earliest_day') {
          replacementValue = moment(combinedData.earliest_or_date).format('DD');
        }

        if (key === 'or_date_earliest_month') {
          replacementValue = moment(combinedData.earliest_or_date).format(
            'MMMM'
          );
        }

        if (key === 'or_date_earliest_year') {
          replacementValue = moment(combinedData.earliest_or_date).format(
            'YYYY'
          );
        }

        if (key === 'or_days_earliest_of_week') {
          replacementValue = moment(combinedData.earliest_or_date).format(
            'dddd'
          );
        }

        const sanitizedReplacementValue = DOMPurify.sanitize(
          String(replacementValue ?? '')
        );
        updatedHtml = updatedHtml.split(tag).join(sanitizedReplacementValue);
      }
    }

    return updatedHtml;
  };

  // Function to check if all images are loaded
  function imagesLoaded(printWindow, callback) {
    const images = printWindow.document.images;
    let loadedCount = 0;

    if (images.length === 0) {
      callback();
      return;
    }

    for (let i = 0; i < images.length; i++) {
      if (images[i].complete) {
        loadedCount++;
        if (loadedCount === images.length) {
          callback();
        }
      } else {
        images[i].addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            callback();
          }
        });
        images[i].addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            callback();
          }
        });
      }
    }
  }

  const handleViewPermit = (type) => {
    getListCms({ type }, (data) => {
      const permitDetails = _.get(data, 'data')[0];
      const itemHtml = _.get(permitDetails, 'attributes.body', '[]');
      const permitList = JSON.parse(itemHtml);
      const transaction = _.get(permitApplication, 'data.attributes', {});
      const bplsPermitApplication = _.get(
        _.get(permitApplication, 'included', []).filter(
          (item) => item.type === 'bpls_business_permit_applications'
        ),
        '0.attributes',
        {}
      );

      const bplsActivities = _.get(
        _.get(permitApplication, 'included', []).filter(
          (item) => item.type === 'bpls_business_activities'
        ),
        '0.attributes',
        {}
      );
      const account = _.get(
        _.get(permitApplication, 'included', []).filter(
          (item) => item.type === 'taxpayers'
        ),
        '0.attributes',
        {}
      );
      const bplsBusiness = _.get(
        _.get(permitApplication, 'included', []).filter(
          (item) => item.type === 'bpls_businesses'
        ),
        '0.attributes',
        {}
      );
      const bplsRetirementsActivities = _.get(
        _.get(permitApplication, 'included', []).filter(
          (item) => item.type === 'bpls_business_retirements_activities'
        ),
        '0.attributes',
        {}
      );

      const combinedData = {
        ...bplsBusiness,
        ...bplsActivities,
        ...transaction,
        ...bplsPermitApplication,
        ...barangayDetails,
        business_address: _.get(bplsPermitApplication, 'address', ''),
        account_address: _.get(account, 'address', ''),
        business_line_multiple: [],
        printed_date_day: '',
        printed_date_day_ordinal: '',
        printed_date_month: '',
        printed_date_year: '',
        printed_days_of_week: '',
        validity_date: '',
        // printed_date: '',
        fees: [],
        designation: '',
        signatory_1_name: '',
        signatory_1_designation: '',
        signatory_1_signature: '',
        signatory_2_name: '',
        signatory_2_designation: '',
        signatory_2_signature: '',
        signatory_3_name: '',
        signatory_3_designation: '',
        signatory_3_signature: '',
        barangay_clearance_signatory_name: _.get(
          barangayDetails,
          'signatory_name',
          ''
        ),
        barangay_clearance_signatory_designation: _.get(
          barangayDetails,
          'signatory_designation',
          ''
        ),
        barangay_clearance_signatory_signature: _.get(
          barangayDetails,
          'signatory_signature',
          ''
        ),
        barangay_logo: _.get(barangayDetails, 'logo', ''),
        brgy_fees: _.get(
          bplsPermitApplication,
          'barangay_clearance_fees.fees',
          ''
        ),
        brgy_fees_total: _.get(
          bplsPermitApplication,
          'barangay_clearance_fees.total_human',
          ''
        ),
        brgy_clearance_no: _.get(
          bplsPermitApplication,
          'barangay_clearance_number',
          ''
        ),
        amount_in_words: '',
        // business_line: '',
        business_line_with_code: '',
        business_lines: '',
        business_lines_with_code: '',
        retired_business_line: _.get(
          bplsRetirementsActivities,
          'business_line_name',
          ''
        ),
        retired_business_lines: '',
        or_date_day: '',
        or_date_month: '',
        or_date_year: '',
        or_days_of_week: '',

        or_date_latest_day: '',
        or_date_latest_month: '',
        or_date_latest_year: '',
        or_days_latest_of_week: '',

        or_date_earliest_day: '',
        or_date_earliest_month: '',
        or_date_earliest_year: '',
        or_days_earliest_of_week: '',

        incharge_middle_name: _.get(bplsBusiness, 'incharge_middle_name') !== null 
          ? _.get(bplsBusiness, 'incharge_middle_name') 
          : '',
        registration_number:
          _.get(bplsBusiness, 'dti_no') ||
          _.get(bplsBusiness, 'sec_no') ||
          _.get(bplsBusiness, 'cda_no') ||
          '',
      };

      const defaultIndex =
        !isEmpty(permitList) && Array.isArray(permitList)
          ? permitList.findIndex((permit) => permit.selected || 0)
          : 0;
      let htmlString = (JSON.parse(itemHtml)[defaultIndex] || {}).body ?? '';
      const values = JSON.parse(
        JSON.stringify(combinedData, (key, value) =>
          value === null ? '' : value
        )
      );
      htmlString = htmlString.replace(
        /\[no_of_employees_residing_area\]/g,
        '[no_of_employees_residing_manila]'
      );
      // htmlString = htmlString.replace(
      //   /\[issuance_date\]/g,
      //   '[or_generated_at]'
      // );
      // htmlString = htmlString.replace(/\[or_date\]/g, '[transaction_date]');
      htmlString = htmlString.replace(/\[area_formatted\]/g, '[area_human]');
      htmlString = htmlString.replace(
        /\[capital_amount_formatted\]/g,
        '[capital_amount_human]'
      );
      htmlString = htmlString.replace(
        /\[monthly_rental_formatted\]/g,
        '[monthly_rental_human]'
      );
      htmlString = htmlString.replace(
        /\[tax_credit_formatted\]/g,
        '[tax_credit_human]'
      );
      htmlString = htmlString.replace(
        /\[office_barangay_code\]/g,
        '[main_office_barangay_code]'
      );
      htmlString = htmlString.replace(
        /\[office_barangay_name\]/g,
        '[main_office_barangay_name]'
      );
      htmlString = htmlString.replace(
        /\[office_display_address\]/g,
        '[main_office_display_address]'
      );
      htmlString = htmlString.replace(
        /\[office_municipality_code\]/g,
        '[main_office_municipality_code]'
      );
      htmlString = htmlString.replace(
        /\[office_municipality_name\]/g,
        '[main_office_municipality_name]'
      );
      htmlString = htmlString.replace(
        /\[office_province_code\]/g,
        '[main_office_province_code]'
      );
      htmlString = htmlString.replace(
        /\[office_province_name\]/g,
        '[main_office_province_name]'
      );
      htmlString = htmlString.replace(
        /\[office_region_code\]/g,
        '[main_office_region_code]'
      );
      htmlString = htmlString.replace(
        /\[office_region_name\]/g,
        '[main_office_region_name]'
      );
      htmlString = htmlString.replace(
        /\[office_street\]/g,
        '[main_office_street]'
      );
      htmlString = htmlString.replace(
        /\[office_zip_code\]/g,
        '[main_office_zip_code]'
      );
      htmlString = htmlString.replace(/\[or_no\]/g, '[or_no]');
      htmlString = htmlString.replace(
        /\[business_status\]/g,
        '[transaction_type]'
      );
      htmlString = htmlString.replace(/\[amount\]/g, '[total_human]');
      htmlString = htmlString.replace(
        /\[taxpayer_address\]/g,
        '[display_address]'
      );
      htmlString = htmlString.replace(
        /\[business_address\]/g,
        '[business_address]'
      );
      htmlString = htmlString.replace(
        /\[account_address\]/g,
        '[account_address]'
      );
      htmlString = htmlString.replace(
        /\[business_line\]/g,
        '[business_line_name]'
      );
      htmlString = htmlString.replace(
        /\[business_line_with_code\]/g,
        '[industrial_code]-[business_line_name]'
      );
      htmlString = htmlString.replace(
        /\[retirement_reason\]/g,
        '[closure_reason]'
      );
      htmlString = htmlString.replace(
        /\[actual_closure_date\]/g,
        '[closure_date]'
      );
      htmlString = htmlString.replace(
        /\[floor_area\]/g,
        '[floor_area_human]'
      );

      const paperStyle = DOMPurify.sanitize(generatePrintStyles());
      const sanitizedTemplate = DOMPurify.sanitize(htmlString);
      const updatedHtmlString = replacePlaceholders(
        sanitizedTemplate,
        values,
        combinedData
      );
      const printWindow = window.open();
      printWindow.document.open();
      printWindow.document.write(paperStyle + updatedHtmlString);
      printWindow.document.close();
      printWindow.focus();

      // Wait for images to load before printing
      imagesLoaded(printWindow, () => {
        printWindow.print();
        printWindow.close();
      });
    });
  };

  const handleViewApplication = (e) => {
    e.preventDefault();

    const args = {
      path: c.BPLS_E2E_EAPPLICATION_URL.replace(
        '{id}',
        _.get(item, 'id')
      ),
      email: _.get(adminProfile, 'attributes.email'),
    };

    getReportAccess(args, (data) => {
      setModal({
        isOpen: true,
        content: <ViewApplication data={data?.res} />,
        title: `View e-Application`,
        modalSize: 'modal-xl',
      });
    });

  };

  const isPrintedApplication = _.get(
    _.get(permitApplication, 'included', []).filter(
      (item) => item.type === 'bpls_business_permit_applications'
    ),
    '0.attributes.is_printed',
    0
  );

  useEffect(() => {
    if (match.params.bpls_id && !_.isEmpty(list)) {
      getItem(match.params.bpls_id);
    }
  }, [match.params.bpls_id, list]);

  const handleUpdateInformation = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal updateList={item} id={item.id} updating={isLoading} />
      ),
      title: `Unified Application Form`,
      modalSize: 'modal-xl',
    });
  };

  const handleAssessRenewApplication = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AssessRenewApplicationModal
          updateList={item}
          id={item.id}
          updating={isLoading}
        />
      ),
      title: `Assess Renew Application`,
      modalSize: 'modal-xl',
    });
  };

  const handleChangeRequestModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangeRequestModal
          updateList={item}
          id={item.id}
          updating={isLoading}
          closeModal={closeModal}
        />
      ),
      title: `Assess Application`,
      modalSize: 'modal-xl',
    });
  };

  const handleRetirementAssessModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <RetirementModal
          updateList={item}
          id={item.id}
          updating={isLoading}
          closeModal={closeModal}
        />
      ),
      title: `Assess Application`,
      modalSize: 'modal-xl',
    });
  };

  const handleAddRemarks = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <AddRemarksModal
          updateList={get(data, 'included.bplsApplication.attributes')}
          id={data.id}
        />
      ),
      title: `Add Business Remarks`,
      modalSize: 'modal-lg',
    });
  };

  const handleViewLogs = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewLogs id={item.id} />,
      title: `View Logs`,
      modalSize: 'modal-xl',
    });
  };

  const handleRecalculateSOADate = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <RecalCalculateSOADate id={item.id} />,
      title: `Recalculate SOA`,
      modalSize: 'modal-md',
    });
  };

  // const handleUploadCTC = e => {
  //   e.preventDefault();

  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <UploadCTCModal
  //         id={item.id}
  //         updateList={_.get(item, 'included.bplsApplication.attributes')}
  //       />
  //     ),
  //     title: `Upload CTC`,
  //     modalSize: 'modal-md',
  //   });
  // };

  // check payment posting
  // const handlePaymentPosting = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <PaymentPostingModal
  //         // transactionInfo={transactionInfo}
  //         // id={selectedTransaction}
  //         // id={match.params.bpls_id}
  //         transactionInfo={item}
  //         id={item.id}
  //         getItem={getItem}
  //         item={item}
  //       />
  //     ),
  //     title: `Check Posting`,
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleUpdateBilling = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateBilling
          id={item.id}
          type={get(item, 'attributes.transaction_type')}
        />
      ),
      title: `Update Billing`,
      modalSize: 'modal-md',
    });
  };

  const handleUpdateBusinessState = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateBusinessState
          id={item.id}
          data={_.get(item, 'included.bplsBusiness.attributes')}
          refreshList={refreshList}
        />
      ),
      title: `Update Business State`,
      modalSize: 'modal-xl',
    });
  };

  const handleUpdateOrDate = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateOrDate id={item.id} data={item} />,
      title: `Update OR Date`,
      modalSize: 'modal-md',
    });
  };

  // const handleManualPaymentPosting = (e) => {
  //   e.preventDefault();

  //   setModal({
  //     isOpen: true,
  //     content: <ManualPaymentPostingModal id={item.id} data={item} />,
  //     title: `Manual Payment Posting`,
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleEndorsingOffice = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <EndorsingOfficeModal
          data={item}
          handleEndorsingOffice={handleEndorsingOffice}
        />
      ),
      title: `Endorsing Office`,
      modalSize: 'modal-xl',
    });
  };

  const checkAssessor = () => {
    if (_.get(item, 'attributes.is_start_assessment') > 0) {
      return (
        +_.get(adminProfile, 'id') === _.get(item, 'attributes.start_assess_by')
      );
    }
    if (_.get(item, 'attributes.is_start_assessment') === 0) return true;
  };

  const handleTagAsForPickUp = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to tag this application for pick-up?',
      (remarks) => {
        forPickUp(
          get(item, 'id'),
          {
            remarks,
          },
          () => {
            getItem(get(item, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsIssued = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to tag as issued this application?',
      (remarks) => {
        issued(
          get(item, 'id'),
          {
            remarks,
          },
          () => {
            getItem(get(item, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleRevokeBusinessClearance = (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure you want to{' '}
        {get(
          item,
          'included.bplsApplication.attributes.brgy_clearance_revoked_at'
        )
          ? 'unrevoke'
          : 'revoke'}{' '}
        this barangay clearance?
      </div>,
      (remarks) => {
        revokeBarangayClearance(get(item, 'id'), { remarks }, () => {
          getItem(get(item, 'id'));
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleRevokeBusinessPermit = (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure you want to{' '}
        {get(item, 'included.bplsApplication.attributes.is_revoked')
          ? 'unrevoke'
          : 'revoke'}{' '}
        this business permit?
      </div>,
      (remarks) => {
        onRevoke(get(item, 'id'), { remarks }, () => {
          getItem(get(item, 'id'));
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleValidateQuarterlyBusinessActivities = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>Are you sure you want to validate this business activities?</div>,
      () => {
        validateBusinessActivity(get(item, 'id'), data.id, {}, () => {
          getItem(get(item, 'id'));
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const validateQuarterlyBusinessConfirmation = useValidateQuarterlyBusiness(
    validatingBusiness,
    isStartAssessment,
    get(item, 'attributes.transaction_status'),
    itemAppStatus,
    () => {
      validateBusiness(get(item, 'id'), {}, () => {
        getItem(get(item, 'id'));
      });
    }
  );

  useEffect(() => {
    if (item.id) {
      getEndorsingOfficesList(item.id);
    }
  }, [item.id]);

  const isValidatedDelinquent = () => {
    if (isDelinquent) {
      return isValidated ? true : false;
    }
    if (!isDelinquent) return true;
  };

  const handleUpdateBarangayBusinessClearanceNumber = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateBarangayBusinessClearanceNumber
          id={_.get(item, 'id')}
          updateList={get(item, 'included.bplsApplication.attributes')}
        />
      ),
      title: 'Update Barangay Business Clearance Number ',
      modalSize: 'modal-md',
    });
  };

  const getPermitType = () => {
    if (permitType === 'RETIREMENT') {
      return 'BUSINESS_RETIREMENT_TEMPLATES';
    }
    return 'BUSINESS_PERMITS';
  };

  const bplsApplicationStatus = _.get(
    item,
    'included.bplsApplication.attributes.status'
  );
  const revokeStatus = ['ISSUED', 'REVOKED'];
  const updateOrStatus = ['FOR PRINTING', 'FOR PICK-UP', 'ISSUED'];

  const isRevokeBtnShow =
    revokeStatus.indexOf(bplsApplicationStatus) > -1 &&
    transactionType !== 'QUARTERLY' &&
    transactionType !== 'DELINQUENT' &&
    Acl(permissions, ['REVOKE BUSINESS PERMIT']);

  const isUpdateOrDateShow =
    updateOrStatus.indexOf(bplsApplicationStatus) > -1 &&
    transactionType !== 'QUARTERLY' &&
    transactionType !== 'DELINQUENT' &&
    Acl(permissions, ['E2E BPLS UPDATE OR DATE']);

  return (
    <div className="card-section-content container-fluid">
      {isLoading && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="p-3">
        <div className="d-flex mb-3">
          <div className="mr-2">
            <div className="d-flex round-image justify-content-center">
              {get(item, 'included.taxPayer.attributes.photo') && (
                <img
                  className="round-image"
                  src={get(item, 'included.taxPayer.attributes.photo')}
                  alt="Profile"
                />
              )}
              {!get(item, 'included.taxPayer.attributes.photo') && (
                <h3 className="d-flex align-items-center initials mb-0">
                  {getInitials(get(item, 'attributes.name'))}
                </h3>
              )}
            </div>
          </div>
          <div className="d-flex flex-column align-items-start flex-grow-1">
            <h1>
              {get(item, 'included.bplsApplication.attributes.business_name')}
            </h1>
            <h4 className="text-primary">{get(item, 'attributes.name')}</h4>
          </div>
        </div>
      </div>

      <div
        className="d-flex justify-content-end flex-wrap mx-3 mb-1"
        style={{ gap: '0.3rem' }}
      >
        {['NEW', 'RENEWAL'].indexOf(transactionType) > -1 &&
        Acl(permissions, ['E2E BPLS E-APPLICATION']) ? (
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            type="button"
            onClick={handleViewApplication}
          >
            View Application
          </button>
        ) : null}

        {_.get(
          item,
          'included.bplsApplication.attributes.display_annual_soa'
        ) ? (
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            type="button"
            onClick={() => handleViewAnnualSOA()}
          >
            View Annual SOA
          </button>
        ) : null}

        {['PENDING', 'WAITING FOR PAYMENT', 'EXPIRED REFERENCE NUMBER'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 && Acl(permissions, ['E2E BPLS E-SOA']) ? (
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            type="button"
            onClick={() => handleViewSOA()}
          >
            View SOA
          </button>
        ) : null}

        {[
          'PAID',
          'FOR PRINTING',
          'RECEIVED',
          'RELEASED',
          'FOR PICK-UP',
          'ISSUED',
        ].indexOf(itemAppStatus) > -1 &&
        _.get(item, 'included.bplsApplication.attributes.e_permit_no') &&
        Acl(permissions, ['VIEW BPLS E-PERMIT']) ? (
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            type="button"
            onClick={() => handleViewPermit(getPermitType())}
          >
            View Permit
          </button>
        ) : null}

        {[
          'PAID',
          'FOR PRINTING',
          'RECEIVED',
          'RELEASED',
          'FOR PICK-UP',
          'ISSUED',
        ].indexOf(itemAppStatus) > -1 &&
        _.get(item, 'included.bplsApplication.attributes.e_permit_no') &&
        _.get(
          item,
          'included.bplsApplication.attributes.with_barangay_clearance'
        ) &&
        Acl(permissions, ['VIEW BPLS BARANGAY CLEARANCE']) ? (
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            type="button"
            onClick={() => handleViewPermit('BARANGAY_CLEARANCE')}
          >
            View Barangay Business Clearance
          </button>
        ) : null}

        {Acl(permissions, ['VIEW BPLS LOGS']) && item && !isEmpty(item) ? (
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            type="button"
            onClick={handleViewLogs}
          >
            Logs
          </button>
        ) : null}
      </div>

      <div
        className="d-flex justify-content-end flex-wrap mx-3 mb-1"
        style={{ gap: '0.3rem' }}
      >
        {/* {transactionType !== 'DELINQUENT' && itemAppStatus === 'PAID'
          ? Acl(permissions, ['UPDATE BPLS PLATE NUMBER']) && (
              <button
                onClick={handleUpdateRegistry}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                type="button"
              >
                Update Business Plate No.
              </button>
            )
          : null} */}

        {itemAppStatus === 'FOR ENDORSING OFFICES ASSESSMENT' ||
        itemAppStatus === 'PAID' ||
        itemAppStatus === 'ISSUED'
          ? ['CHANGE', 'NEW', 'RENEWAL'].indexOf(transactionType) > -1 && (
              <button
                disabled={isLoading}
                onClick={handleEndorsingOffice}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              >
                Endorsing Office
              </button>
            )
          : null}

        {['COMPUTED', 'EXPIRED SOA'].indexOf(itemAppStatus) > -1
          ? Acl(permissions, ['REGENERATE BPLS SOA']) && (
              <button
                disabled={isLoading}
                onClick={handleRecalculateSOADate}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              >
                Recalculate SOA
              </button>
            )
          : ''}

        {checkAssessor() &&
          permitType === 'QUARTERLY' &&
          isValidated === 0 &&
          validateQuarterlyBusinessConfirmation.component}

        {match.params.transaction_type === 'new' &&
          Acl(permissions, ['E2E BPLS START PERMIT ASSESSMENT']) &&
          isPrintedApplication === 1 &&
          checkAssessor() &&
          !_.isEmpty(endorsingOfficesList) &&
          forwardToEndorsingOfficeConfirmation.component}

        {match.params.transaction_type === 'renewal' &&
          Acl(permissions, ['E2E BPLS RENEWAL START PERMIT ASSESSMENT']) &&
          isPrintedApplication === 1 &&
          checkAssessor() &&
          isValidated === 1 &&
          !_.isEmpty(endorsingOfficesList) &&
          forwardToEndorsingOfficeConfirmation.component}

        {match.params.transaction_type === 'change' &&
          Acl(permissions, ['E2E BPLS CHANGE START PERMIT ASSESSMENT']) &&
          isPrintedApplication === 1 &&
          checkAssessor() &&
          isValidated === 1 &&
          !_.isEmpty(endorsingOfficesList) &&
          forwardToEndorsingOfficeConfirmation.component}

        {Acl(permissions, ['E2E BPLS FORWARD TO LICENSE']) &&
          checkAssessor() &&
          (permitType === 'NEW' ||
            // permitType; ===
            //   'RENEWAL' ||
            // permitType; ===
            //   'CHANGE' ||
            permitType === 'RETIREMENT') &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          forwardToLicenseConfirmation.component}

        {Acl(permissions, ['E2E BPLS RENEWAL FORWARD TO LICENSE']) &&
          checkAssessor() &&
          permitType === 'RENEWAL' &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          _.isEmpty(endorsingOfficesList) &&
          forwardToLicenseConfirmation.component}

        {Acl(permissions, ['E2E BPLS CHANGE FORWARD TO LICENSE']) &&
          checkAssessor() &&
          permitType === 'CHANGE' &&
          get(item, 'included.bplsBusiness.attributes.bin') &&
          isValidated === 1 &&
          forwardToLicenseConfirmation.component}

        {Acl(permissions, ['E2E GENERATE SOA']) &&
          checkAssessor() &&
          generateSOAConfirmation.component}

        {Acl(permissions, ['E2E BPLS GENERATE BIN']) &&
          checkAssessor() &&
          permitType === 'NEW' &&
          generateBINHooks.component}

        {get(item, 'included.bplsBusiness.attributes.taxpayer_id') !== null
          ? Acl(permissions, ['E2E BPLS INITIAL COMPUTATION']) &&
            permitType !== 'CHANGE' &&
            permitType !== 'RETIREMENT' &&
            permitType !== 'DELINQUENT' &&
            permitType !== 'QUARTERLY' &&
            checkAssessor() &&
            isValidatedDelinquent() &&
            initialComputationHooks.component
          : ''}

        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        itemAppStatus === 'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'new' && (
              <button
                disabled={isLoading}
                onClick={handleUpdateInformation}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
              >
                Assess Application
              </button>
            )
          : ''}

        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        itemAppStatus === 'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'renewal' && (
              <button
                disabled={isLoading}
                onClick={handleAssessRenewApplication}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
              >
                Assess Application
              </button>
            )
          : ''}

        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        itemAppStatus === 'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'change' && (
              <button
                disabled={isLoading}
                onClick={handleChangeRequestModal}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
              >
                Assess Change Request
              </button>
            )
          : ''}
        {['FOR CHECKING'].indexOf(
          _.get(item, 'attributes.transaction_status')
        ) > -1 &&
        _.get(item, 'attributes.start_assess_by') &&
        itemAppStatus === 'FOR PERMIT PROCESS' &&
        checkAssessor()
          ? Acl(permissions, ['E2E BPLS VALIDATE BUSINESS']) &&
            match.params.transaction_type === 'retirement' && (
              <button
                disabled={isLoading}
                onClick={handleRetirementAssessModal}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
              >
                Assess
              </button>
            )
          : ''}

        {_.get(CMS_COMPONENTS, 'BPLS_MANUAL_PROCESSING')
          ? ['FOR PRINTING'].indexOf(
              _.get(item, 'attributes.transaction_status')
            ) > -1 &&
            Acl(permissions, ['E2E BPLS TAG AS FOR PICK-UP']) && (
              <button
                disabled={isLoading}
                type="button"
                onClick={handleTagAsForPickUp}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              >
                Tag as for Pick-up
              </button>
            )
          : ''}

        {_.get(CMS_COMPONENTS, 'BPLS_MANUAL_PROCESSING')
          ? ['FOR PICK-UP'].indexOf(
              _.get(item, 'attributes.transaction_status')
            ) > -1 &&
            Acl(permissions, ['E2E BPLS TAG AS ISSUED']) && (
              <button
                disabled={isLoading}
                type="button"
                onClick={handleTagAsIssued}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              >
                Tag as Issued
              </button>
            )
          : ''}

        {['FOR PRINTING', 'RECEIVED', 'FOR PICK-UP', 'ISSUED', 'PAID'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')) > -1 &&
          ['NEW', 'RENEWAL', 'CHANGE', 'RETIREMENT'].indexOf(transactionType) > -1
        ? Acl(permissions, ['BPLS UPDATE BUSINESS STATE']) && (
          <button
            disabled={isLoading}
            onClick={handleUpdateBusinessState}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
          >
            Update Business State
          </button>
        ) : ''}

        {['FOR PRINTING', 'RECEIVED', 'FOR PICK-UP', 'ISSUED', 'PAID'].indexOf(
          itemAppStatus
        ) > -1
          ? Acl(permissions, ['E2E BPLS UPDATE BILLING']) &&
            transactionType !== 'QUARTERLY' &&
            transactionType !== 'DELINQUENT' && (
              <button
                disabled={isLoading}
                onClick={handleUpdateBilling}
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
              >
                Update Billing
              </button>
            )
          : ''}

        {isUpdateOrDateShow ? (
          <button
            disabled={isLoading}
            onClick={handleUpdateOrDate}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
          >
            Update OR Date
          </button>
        ) : null}

        {match.params.transaction_type === 'new' &&
        Acl(permissions, ['E2E BPLS START PERMIT ASSESSMENT']) &&
        checkAssessor() &&
        isPrintedApplication === 1
          ? startAssessment.component
          : null}

        {match.params.transaction_type === 'renewal' &&
        Acl(permissions, ['E2E BPLS RENEWAL START PERMIT ASSESSMENT']) &&
        checkAssessor() &&
        isPrintedApplication === 1
          ? startAssessment.component
          : null}

        {match.params.transaction_type === 'change' &&
        Acl(permissions, ['E2E BPLS CHANGE START PERMIT ASSESSMENT']) &&
        checkAssessor() &&
        isPrintedApplication === 1
          ? startAssessment.component
          : null}

        {((match.params.transaction_type !== 'renewal' &&
          Acl(permissions, ['E2E BPLS START LICENSE ASSESSMENT'])) ||
          (match.params.transaction_type === 'renewal' &&
            Acl(permissions, ['E2E BPLS RENEWAL LICENSE ASSESSMENT']))) &&
        isPrintedApplication === 1 &&
        checkAssessor()
          ? startLicenseAssessment.component
          : null}

        {Acl(permissions, ['E2E BPLS APPROVE OWNERSHIP']) &&
          approveOwnershipComputation.component}

        {match.params.transaction_type !== 'change' &&
        Acl(permissions, ['E2E BPLS APPROVE'])
          ? approveConfirmation.component
          : null}
      </div>

      <div
        className="d-flex justify-content-end flex-wrap mx-3 mb-1"
        style={{ gap: '0.3rem' }}
      >
        {isRevokeBtnShow ? (
          <button
            type="button"
            onClick={handleRevokeBusinessPermit}
            className="btn btn-danger font-weight-bold"
            disabled={isLoading}
          >
            {get(item, 'included.bplsApplication.attributes.is_revoked')
              ? 'Unrevoke Permit'
              : 'Revoke Permit'}
          </button>
        ) : null}

        {['ISSUED', 'REVOKED'].indexOf(itemAppStatus) > -1 &&
        Acl(permissions, ['REVOKE BARANGAY CLEARANCE']) &&
        _.get(
          item,
          'included.bplsApplication.attributes.with_barangay_clearance'
        ) ? (
          <button
            type="button"
            onClick={handleRevokeBusinessClearance}
            className="btn btn-danger font-weight-bold"
            disabled={isLoading}
          >
            {get(
              item,
              'included.bplsApplication.attributes.brgy_clearance_revoked_at'
            )
              ? 'Unrevoke Barangay Clearance'
              : 'Revoke Barangay Clearance'}
          </button>
        ) : null}

        {Acl(permissions, ['E2E BPLS REJECT']) && checkAssessor()
          ? rejectConfirmation.component
          : null}

        {Acl(permissions, ['CANCEL BPLS APPLICATION'])
          ? cancelApplicationConfirmation.component
          : null}

        {Acl(permissions, ['E2E BPLS RELEASE'])
          ? releaseConfirmation.component
          : null}

        {Acl(permissions, ['BPLS CANCEL SOA'])
          ? cancelSoaConfirmation.component
          : null}

        {Acl(permissions, ['E2E BPLS RETURN TO PERMIT']) &&
        checkAssessor() &&
        ['NEW'].indexOf(transactionType) > -1
          ? returnToPermitConfirmation.component
          : null}

        {Acl(permissions, ['E2E BPLS RENEWAL RETURN TO PERMIT']) &&
        checkAssessor() &&
        ['RENEWAL'].indexOf(transactionType) > -1
          ? returnToPermitConfirmation.component
          : null}

        {Acl(permissions, ['E2E BPLS CHANGE RETURN TO PERMIT']) &&
        checkAssessor() &&
        ['CHANGE'].indexOf(transactionType) > -1
          ? returnToPermitConfirmation.component
          : null}
      </div>

      <div className="p-3">
        <Tabs>
          <SideScrollingTab dragToScroll>
            <TabList>
              <Tab>Transaction</Tab>
              <Tab>Account</Tab>
              <Tab>Business</Tab>
              <Tab>Location</Tab>
              <Tab>Activities</Tab>
              {showFsisIntegration && (
                <Tab>Fire Safety</Tab>
              )}
              {get(item, 'attributes.transaction_type') !== 'QUARTERLY' && (
                <Tab>Requirements</Tab>
              )}
              {get(item, 'included.bplsPermitFees', []).length > 0 && (
                <Tab>Fees</Tab>
              )}
              {/* <Tab>Location</Tab> */}
            </TabList>
          </SideScrollingTab>
          <TabPanel>
            <TransactionInformation
              data={item}
              handleUpdateBusinessPlateNumber={handleUpdateRegistry}
              handleUpdateBarangayBusinessClearanceNumber={
                handleUpdateBarangayBusinessClearanceNumber
              }
            />
          </TabPanel>
          <TabPanel>
            <TaxpayerInformation data={get(item, 'included.taxPayer')} />
          </TabPanel>
          <TabPanel>
            <BusinessInformation
              data={get(item, 'included.bplsBusiness')}
              remarks={item}
              handleAddRemarks={handleAddRemarks}
              isLoading={isLoading}
              isAssessor={checkAssessor()}
            />
          </TabPanel>
          <TabPanel>
            <BusinessAddress 
              data={get(item, 'included.bplsBusiness')}
            />
          </TabPanel>
          <TabPanel>
            <BusinessActivities
              data={get(item, 'included.bplsBusinessActivities')}
              businessInformation={item}
              isStartAssessment={isStartAssessment}
              checkAssessor={checkAssessor}
              handleValidateQuarterlyBusinessActivities={
                handleValidateQuarterlyBusinessActivities
              }
            />
          </TabPanel>
          {showFsisIntegration && (
            <TabPanel>
              <FireSafetyInformation
                data={fsisApplication}
              />
            </TabPanel>
          )}
          {get(item, 'attributes.transaction_type') !== 'QUARTERLY' && (
            <TabPanel>
              <RequirementsTabs
                applicationRequirements={get(
                  item,
                  'included.bplsPermitRequirements'
                )}
                businessLinesRequirements={get(
                  item,
                  'included.bplsBusinessLineRequirements'
                )}
              />
            </TabPanel>
          )}
          {get(item, 'included.bplsPermitFees', []).length > 0 && (
            <TabPanel>
              <FinalFeesInformation
                data={get(item, 'included.bplsPermitFees')}
                granTotal={get(item, 'attributes.amount')}
                permitId={match.params.bpls_id}
                applicationInfo={get(item, 'included.bplsApplication')}
                isApproved={Boolean(get(item, 'attributes.approve_at'))}
              />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </div>
  );
}

Content.propTypes = {
  adminProfile: PropTypes.instanceOf(Object).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  permitApplication: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  toggleAssessment: PropTypes.instanceOf(Function).isRequired,
  toggleLicenseAssessment: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  assisting: PropTypes.bool.isRequired,
  generatingBIN: PropTypes.bool.isRequired,
  initialComputing: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  releasing: PropTypes.bool.isRequired,
  ownershipApproving: PropTypes.bool.isRequired,
  generateBIN: PropTypes.instanceOf(Function).isRequired,
  initialComputation: PropTypes.instanceOf(Function).isRequired,
  approve: PropTypes.instanceOf(Function).isRequired,
  // reject: PropTypes.instanceOf(Function).isRequired,
  release: PropTypes.instanceOf(Function).isRequired,
  approveOwnership: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  generatingSOA: PropTypes.bool.isRequired,
  generateSOA: PropTypes.instanceOf(Function).isRequired,
  forwardingToLicense: PropTypes.bool.isRequired,
  forwardToLicense: PropTypes.instanceOf(Function).isRequired,
  cancellingSoa: PropTypes.bool.isRequired,
  cancelSoa: PropTypes.instanceOf(Function).isRequired,
  cancellingApplication: PropTypes.bool,
  cancelApplication: PropTypes.instanceOf(Function).isRequired,
  returningToPermit: PropTypes.bool.isRequired,
  returnToPermit: PropTypes.instanceOf(Function).isRequired,
  recalculatingSOA: PropTypes.bool.isRequired,
  recalculateSOA: PropTypes.instanceOf(Function).isRequired,
  inquirePreviousOR: PropTypes.instanceOf(Function).isRequired,
  getPermitList: PropTypes.instanceOf(Function).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  param: PropTypes.instanceOf(Object).isRequired,
  forwardingToEndorsingOffice: PropTypes.bool.isRequired,
  forwardToEndorsingOffice: PropTypes.instanceOf(Function).isRequired,
  getListCms: PropTypes.instanceOf(Function).isRequired,
  getPaperList: PropTypes.instanceOf(Function).isRequired,
  forPickUp: PropTypes.instanceOf(Function).isRequired,
  issued: PropTypes.instanceOf(Function).isRequired,
  getEndorsingOfficesList: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficesList: PropTypes.instanceOf(Object).isRequired,
  revokeBarangayClearance: PropTypes.instanceOf(Function).isRequired,
  onRevoke: PropTypes.instanceOf(Function).isRequired,
  validateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  validateBusiness: PropTypes.instanceOf(Function).isRequired,
  validatingBusiness: PropTypes.bool.isRequired,
  getBarangayDetails: PropTypes.instanceOf(Function).isRequired,
  barangayDetails: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => {
  return {
    adminProfile: getJson('enableProfile'),
    item: get(api, `${c.ITEM}.item`) || {},
    permitApplication: get(api, `${c.ITEM}.res`) || {},
    isLoading: api.loading.indexOf(c.ITEM) > -1,
    assisting: api.loading.indexOf(c.TOGGLE_ASSESSMENT) > -1,
    initialComputing: api.loading.indexOf(c.INITIAL_COMPUTATION) > -1,
    approving: api.loading.indexOf(c.APPROVE) > -1,
    rejecting: api.loading.indexOf(c.REJECT) > -1,
    releasing: api.loading.indexOf(c.RELEASE) > -1,
    ownershipApproving: api.loading.indexOf(c.APPROVE_OWNERSHIP) > -1,
    permissions: getJson('permissions'),
    generatingSOA: api.loading.indexOf(c.GENERATE_SOA) > -1,
    forwardingToLicense: api.loading.indexOf(c.FORWARD_TO_LICENSE) > -1,
    generatingBIN: api.loading.indexOf(c.GENERATE_BIN) > -1,
    cancellingSoa: api.loading.indexOf(c.CANCEL_SOA) > -1,
    cancellingApplication: api.loading.indexOf(c.CANCEL_APPLICATION) > -1,
    returningToPermit: api.loading.indexOf(c.RETURN_TO_PERMIT) > -1,
    recalculatingSOA: api.loading.indexOf(c.RECALCULATE_SOA) > -1,
    forwardingToEndorsingOffice:
      api.loading.indexOf(c.FORWARD_TO_ENDORSING_OFFICE) > -1,
    itemSettings:
      (_.get(api, `${cmsConstants.GET_SETTINGS}.list`) || [])[0] || {},
    forPickingUp: api.loading.indexOf(c.FOR_PICK_UP) > -1,
    issuing: api.loading.indexOf(c.ISSUED) > -1,
    endorsingOfficesList:
      _.get(api, `${c.GET_ENDORSING_OFFICES_LIST}.list`) || [],
    validatingBusiness: api.loading.indexOf(c.VALIDATE_BUSINESS) > -1,
    barangayDetails:
      _.get(api, `${c.GET_BARANGAY_DETAILS}.item.0.attributes`) || {},
    id: _.get(match, 'params.id') || '',
  };
};

const enhance = flowRight([
  withRouter,
  connect(mapStateToProps, { ...actions, ...cmsActions }),
]);

export default enhance(Content);
